<template>
  <ul class="chartBox">
    <!-- {{
      option
    }} -->
    <!-- {{
      deliveryNum
    }} -->
    <div @click="backToFirst" v-if="isSecend" class="back">返回</div>
    <li v-if="type === 'bar'">
      <histogram
        :chartOption="option"
        @echartClick="echartClick"
        :ref="id"
        :id="id"
      ></histogram>
    </li>
    <li v-if="type === 'pie'">
      <pie-chart
        :chartOption="option"
        @echartClick="echartClick"
        :ref="id"
        :id="id"
      ></pie-chart>
    </li>
    <li v-if="type === 'line'">
      <lineChart
        :chartOption="option"
        @echartClick="echartClick"
        :ref="id"
        :id="id"
      ></lineChart>
    </li>

    <div class="m-legend">
      <div
        v-if="type === 'pie' && this.activeChild !== '1,3,7,20'"
        class=" rate"
      >
        <template v-for="(item, i) in ['freight', 'value']">
          <span class="marR20" :key="item" style="color: #090909">
            <i class="dot" :style="'background-color:' +  option.color[i]"></i>
            <!-- <i class="fa legend-icon" :style="'color:' + option.color[i]"
              >&#xe7a5;</i
            > -->
            <span>{{ item }}</span>
            <!-- <span>{{ "(" + item.sum + ")" }}</span> -->
          </span>
        </template>
      </div>
      <template v-if="this.activeChild !== '3'">
        <span
          v-if="this.$parent.sortSel.indicators1 === 1"
          class="colBlack fontWeight"
          >Total number of shipments (single)：</span
        >
        <template v-for="(item, i) in option.sortLabel">
          <span class="marR20" :key="i" style="color: #090909">
            <!-- <i class="fa legend-icon" :style="'color:' + secendColor[i]"
              >&#xe7a5;</i
            > -->
            <i class="dot" :style="'background-color:' + secendColor[i]"></i>
            <span>{{ item.name }}</span>
            <span>{{ "(" + item.sum + ")" }}</span>
          </span>
        </template>
      </template>
    </div>
  </ul>
</template>
<script>
import histogram from "./histogram.vue";
import pieChart from "./pieChart.vue";
import lineChart from "./lineChart.vue";
export default {
  components: { histogram, lineChart, pieChart },
  props: {
    id: { type: String },
    type: { type: String, default: "bar" }, //"bar, pie, line"
    barWidth: { type: Number, default: 20 },
    chartDatas: { type: Object },
    activeChild: String,
    deliveryNum: {
      type: Object
    },
    sortSel: {
      type: Object
    }
    // secondData: { type: Object }
  },
  data() {
    return {
      option: {},
      isSecend: false,
      secendColor: [
        "#0B5DE4 ",
        "#91BAFF",
        "#66A0FF",
        "#3aebbf",
        "#014fb1",
        "#ffcf0d",
        "#efbd68",
        "#452a8d",
        "#ff6600",
        "#da0000",
        "#9999ff",
        "#ccccff"
      ]
      // color: []
      // rateLabel: []
    };
  },

  // watch{
  //   flag(){

  //   }
  // }
  // let flag= true

  watch: {
    // deliveryNum: {
    //   handler: function(val) {
    //     this.startCompute();
    //   },

    //   deep: true
    // },
    type(val) {
      this.startCompute();
    },
    chartDatas: {
      handler: function(val) {
        console.log("🚀 ~ val", val);
        this.startCompute();
        // this.isSecend = false;
      },
      deep: true
    },
    activeChild() {
      this.isSecend = false;
    },
    sortSel: {
      handler: function(val) {
        this.isSecend = false;
        // this.isSecend = false;
      },
      deep: true
    }
  },
  mounted() {
    console.log("byhcart");
    this.startCompute();
    // debugger;
  },
  // mounted() {
  //   this.$forceUpdate();
  // },
  methods: {
    // 根据type 显示对应图像  并进行计算option
    startCompute() {
      //快递\FBA
      // if (this.$parent.activeChild === "1" || "20") {
      //   const objClone = JSON.parse(JSON.stringify(this.chartDatas));

      //   this.chartDatas = [999, 999, 999];
      // }
      // clickChart(){
      //     chartDatas=objClone

      // }
      // clickRturn(){
      //   this.startCompute();
      // }
      // debugger;
      if (this.type === "bar") {
        this.getBarOption();
      }
      if (this.type === "pie") {
        this.getPieOption();
      }
      if (this.type === "line") {
        this.getLineOption();
      }
    },
    // 对Histogram数据处理
    getBarOption() {
      let { series, sortTitle } = this.chartDatas;

      console.log("🚀 ~ series", series);

      // 对这些数据进行中间处理
      series = series.map(item => {
        let widths;
        if (
          this.$parent.sortSel.indicators1 == "2" ||
          this.$parent.sortSel.indicators1 == "3"
        ) {
          widths = this.barWidth;
        } else {
          widths =
            this.activeChild !== "1,3,7,20"
              ? !this.isSecend
                ? 50
                : this.barWidth
              : this.barWidth; //---柱形宽度
        }
        return {
          name: item.name,
          type: "bar",
          barWidth: widths,

          barGap: "50%",
          data: item.data,
          label: {
            show: true,
            position: "top",
            color: "#363636",
            formatter: params => {
              if (params.value > 0) {
                return this.numFormat(params.value);
              } else {
                return " ";
              }
            }
          }
        };
      });

      let {
        title,
        color,
        legend,
        grid,
        xAxis,
        yAxis,
        tooltip
      } = this.commonInfo();
      // debugger;
      this.option = {
        grid: grid,
        title: title,
        tooltip: tooltip,
        color: color,
        legend: legend,
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
        sortLabel: this.coumpouteNum(
          this.deliveryNum.secondData
            ? this.deliveryNum.secondData
            : this.deliveryNum.series
        )
      };
    },
    // 对Line chart数据处理
    getLineOption() {
      let { series, sortTitle } = this.chartDatas;
      series = series.map(item => {
        return {
          data: item.data,
          name: item.name,
          type: "line",
          label: {
            show: true,
            position: "top",
            color: "#363636",
            formatter: params => {
              return this.numFormat(params.value);
            }
          }
        };
      });
      let { title, color, grid, legend, xAxis, yAxis } = this.commonInfo();
      let tooltip = {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ededed",
        borderWidth: 1,
        formatter: params => {
          let arr = [];
          params.forEach(element => {
            arr.push(element.seriesName + "：" + element.value);
          });
          return arr.join("<br />");
        },
        textStyle: {
          color: "#000",
          fontSize: 12
        }
      };
      this.option = {
        grid: grid,
        tooltip: tooltip,
        title: title,
        color: color,
        legend: legend,
        xAxis: xAxis,
        yAxis: yAxis,
        series: series,
        sortLabel: this.coumpouteNum(
          this.deliveryNum.secondData
            ? this.deliveryNum.secondData
            : this.deliveryNum.series
        )
      };
    },
    // 对Pie chart数据处理
    getPieOption() {
      let { series, sortTitle } = this.chartDatas;
      // 分成三块Pie chart
      let arr = [];
      sortTitle.forEach(() => {
        arr.push([]);
      });
      // debugger;
      let sortLabel = this.coumpouteNum(
        this.deliveryNum.secondData
          ? this.deliveryNum.secondData
          : this.deliveryNum.series
      );
      //freightvalue
      // this.rateLabel = this.coumpouteNum(series);
      let lineSeries = series.map(item => {
        return {
          name: item.name,
          type: "line",
          data: item.data,
          // 不需要绘制线条
          itemStyle: {
            opacity: 0
          },
          lineStyle: {
            opacity: 0
          }
        };
      });
      // debugger;
      series.forEach(item => {
        item.data.forEach((element, i) => {
          arr[i].push({ name: item.name, value: element });
        });
      });

      series = arr.map((item, i) => {
        const pieMap = {
          3: [270 + i * 295, 180],
          2: [350 + i * 450, 180],
          1: ["50%", "50%"]
        };
        return {
          type: "pie",
          radius: "55%",
          // center: ["50%", "50%"],
          center: pieMap[arr.length],
          height: 266,
          label: {
            normal: {
              show: true,
              color: "#363636",
              formatter: `{d}` + "%"
              // formatter: " {c} ({d}%)"
            }
          },
          data: item
        };
      });
      // 由于Pie chart没有分割线 所以时Line chart+Pie chart绘制 只不过Line chart的线条是不显示
      let { title, color, grid, legend, xAxis, yAxis } = this.commonInfo();
      // this.color = color;
      this.option = {
        title: title,
        tooltip: {
          trigger: "item",
          backgroundColor: "#fff",
          borderColor: "#ededed",
          borderWidth: 1,
          formatter: params => {
            return params.name + "：" + params.percent + "%";
          },
          textStyle: {
            color: "#000",
            fontSize: 12
          }
        },
        grid: grid,
        // color: this.isSecend ? color : ["#0c5ee4", "#000000"],
        color: color,
        legend: legend,
        xAxis: xAxis,
        yAxis: yAxis,
        series: [...series, ...lineSeries],
        sortLabel: sortLabel
      };
    },

    echartClick(val) {
      console.log("🚀 ~ val", val);
      // debugger;
      if (this.chartDatas.secondData) {
        this.chartDatas.series = this.chartDatas.secondData;
        this.isSecend = true;
      }
    },

    // 通用设置
    commonInfo() {
      let { title, series, sortTitle } = this.chartDatas;

      // #0B5DE4  快递  |  #91BAFF 空运  |   #66A0FF   fba   |  #4B88ED specialLine
      // let color = [
      //   "#0B5DE4 ",
      //   "#91BAFF",
      //   "#66A0FF",
      //   "#3aebbf",
      //   "#014fb1",
      //   "#ffcf0d",
      //   "#efbd68",
      //   "#452a8d",
      //   "#ff6600",
      //   "#da0000",
      //   "#9999ff",
      //   "#ccccff"
      // ]; //颜色关系
      let legend = {
        show: false
      };
      let xAxis = {
        // axisLabel:{interval:0}
        //x轴设置
        axisLabel: {
          show: true,
          interval: 0,
          textStyle: {
            color: "#000",
            fontSize: "12"
          }
        },
        data: sortTitle,
        // data: [
        //   "2020-11-13-2020-11-15",
        //   "2020-11-19-2020-11-20",
        //   "2020-08-13-2021-01-12",
        //   "2020-08-12-2021-01-24",
        //   "2020-08-13-2021-01-26"
        // ],
        axisLine: {
          lineStyle: {
            color: "#E7E7E7",
            width: 1
          }
        },
        splitLine: {
          show: false
        }
      };
      //  y轴设置
      let yAxis = {
        type: "value",
        nameTextStyle: {
          color: "#000"
        },
        splitNumber: 3, //虽然设置了 但是这个并没啥用  还是会自动计算
        splitLine: {
          show: true, //  改变轴线颜色
          lineStyle: {
            color: "#e7e7e7"
          }
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#363636"
          }
        },
        axisLabel: {
          fontSize: 12,
          formatter: val => {
            return this.numFormat(val);
          }
        },
        axisTick: {
          show: false
        }
      };
      let titleOpt = {};
      // Line chart的显示不同
      let tooltip = {
        trigger: "item",
        backgroundColor: "#fff",
        borderColor: "#ededed",
        borderWidth: 1,
        formatter: params => {
          return params.seriesName + "：" + params.value;
        },
        textStyle: {
          color: "#000",
          fontSize: 12
        }
      };
      let grid = {
        height: 225
      };
      let charColor;
      if (this.chartDatas.secondData) {
        if (this.isSecend) {
          charColor = [...this.secendColor];
        } else {
          charColor = ["#91BAFF", "#3aebbf"];
        }
      } else {
        charColor = [...this.secendColor];
      }
      return {
        grid: grid,
        tooltip: tooltip,
        title: titleOpt,
        color: charColor,
        legend: legend,
        xAxis: xAxis,
        yAxis: yAxis
      };
    },
    // 需求： 超过多少 需要做一定显示处理
    numFormat(value) {
      if (value < 1000) {
        return value;
      }
      if (value >= 1000 && value < 10000) {
        return this.InterceptUnit(value / 1000, 2) + "K";
      }
      if (value >= 10000 && value < 100000000) {
        return this.InterceptUnit(value / 10000, 2) + "myriad";
      }
      if (value >= 100000000) {
        return this.InterceptUnit(value / 100000000, 2) + "hundred million";
      }
    },
    // 对数据求和 用于下方 Total number of shipments (single)栏 显示
    coumpouteNum(series) {
      let arr = [];
      // debugger;
      series.forEach(element => {
        let max = 0;
        let data = element.data;
        max = data.reduce(function(prev, curr, idx, data) {
          return prev + curr;
        });
        let strMax = this.numFormat(max);

        arr.push({
          name: element.name,
          sum: strMax
        });
      });
      return arr;
    },
    backToFirst() {
      this.isSecend = false;
      this.chartDatas.series = this.chartDatas.firstData;
    }
  }
  // updated() {
  // this.isSecend = false;
  // }
};
</script>
<style scoped>
.chartsBg {
  background: white;
}
.chartBox {
  position: relative;
}
.m-legend {
  position: absolute;
  bottom: -10px;
  width: 100%;
  text-align: center;
}
.rate {
  /* bottom: 0; */
  width: 100%;
  text-align: center;
}
.legend-icon {
  font-size: 27px;
  width: 20px;
  height: 18px;
  overflow: hidden;
}
.back {
  position: absolute;
  right: 80px;
  top: 50px;
  width: 68px;
  height: 28px;
  border: 1px solid #0c5ee4;
  background: #0c5ee4;
  color: #fff;
  border-radius: 25px;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  z-index: 88;
}
.dot {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/statement/byCharts/byCharts.vue